// Domain error taxonomy shared between src/ and functions/.
//
// Each error carries a `code` drawn from the same vocabulary as Firebase's
// HttpsError codes (see functions/index.js), so a Cloud Function can do
// `new HttpsError(error.code, error.message)` without a translation layer,
// while src/ can catch these directly without any Firebase dependency.

class DomainError extends Error {
  constructor(message, code = 'internal', details = undefined) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    if (details !== undefined) this.details = details;
  }
}

class NotFoundError extends DomainError {
  constructor(resource, id) {
    super(`${resource} not found${id ? `: ${id}` : ''}`, 'not-found', { resource, id });
  }
}

class ValidationError extends DomainError {
  constructor(message, fieldErrors = undefined) {
    super(message, 'invalid-argument', fieldErrors);
  }
}

class ConflictError extends DomainError {
  constructor(message) {
    super(message, 'already-exists');
  }
}

class PermissionError extends DomainError {
  constructor(message) {
    super(message, 'permission-denied');
  }
}

class PreconditionError extends DomainError {
  constructor(message) {
    super(message, 'failed-precondition');
  }
}

class UnauthenticatedError extends DomainError {
  constructor(message = 'You must be logged in to do this.') {
    super(message, 'unauthenticated');
  }
}

class IncompleteProfileError extends PreconditionError {
  constructor(message = 'Please complete your profile before booking a meal.') {
    super(message);
    this.name = 'IncompleteProfileError';
    this.profileLink = '/profile';
  }
}

const isDomainError = (error) => error instanceof DomainError;

module.exports = {
  DomainError,
  NotFoundError,
  ValidationError,
  ConflictError,
  PermissionError,
  PreconditionError,
  UnauthenticatedError,
  IncompleteProfileError,
  isDomainError,
};
